/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m9 0 4.1265 7.336A8.5035 8.5035 0 0 1 15.5 7c4.6944 0 8.5 3.8056 8.5 8.5S20.1944 24 15.5 24c-4.5266 0-8.2267-3.5383-8.4855-8H0L9 0Zm.019 16c.2553 3.3562 3.0594 6 6.481 6 3.5899 0 6.5-2.9101 6.5-6.5S19.0899 9 15.5 9a6.531 6.531 0 0 0-1.3577.1418L18 16H9.019Zm-5.5993-2L9 4.0795 14.5803 14H3.4197Z"
    clipRule="evenodd"
  />,
  'MenuDevelop'
);
